/** Widths are calculated from the visible page only; no data or text is stored. */
export function fitContentWidth(widths: readonly number[], padding = 28, minimum = 72, maximum = 480): number {
  const widest = widths.reduce((result, width) => Number.isFinite(width) ? Math.max(result, width) : result, 0);
  return Math.round(Math.min(maximum, Math.max(minimum, widest + padding)));
}

export function autoFitColumnWidth(table: HTMLTableElement, index: number, minimum = 72, maximum = 480): number {
  const cells = [table.tHead?.rows[0]?.cells[index], ...Array.from(table.tBodies).flatMap(body => Array.from(body.rows).slice(0, 100).map(row => row.cells[index]))]
    .filter((cell): cell is HTMLTableCellElement => Boolean(cell && cell.colSpan === 1));
  const canvas = document.createElement("canvas");
  const context = canvas.getContext("2d");
  const widths = cells.flatMap(cell => {
    const style = window.getComputedStyle(cell);
    if (context) context.font = style.font || `${style.fontSize} ${style.fontFamily}`;
    const parts = Array.from(cell.querySelectorAll<HTMLElement>("strong,small,button,a,input,select,textarea"));
    const lines = parts.length ? parts.map(part => part instanceof HTMLInputElement || part instanceof HTMLTextAreaElement ? part.value : part.textContent || "") : [(cell.innerText || cell.textContent || "")];
    return lines.flatMap(value => value.split(/\n/).map(line => context ? context.measureText(line.trim()).width : line.trim().length * 8));
  });
  return fitContentWidth(widths, 28, minimum, maximum);
}
